"use client";

import React from "react";
import { ImageGalleryController } from "./ImageGalleryController";

interface ImageGalleryProcessorProps { }

export const ImageGalleryProcessor = (props: ImageGalleryProcessorProps): null =>
{
    React.useEffect(() =>
    {
        const controllers = Array.from(document.querySelectorAll<HTMLElement>("[data-logic-feature='image-gallery']")).map(element => new ImageGalleryController(element));

        return () =>
        {
            controllers.forEach(controller => controller.dispose());
        };
    }, []);

    return null;
};